import { excuseApi } from "../commons/http";

class BankTransaction {
  constructor(data = {}) {
    this.id = data.id;
    this.amount = data.amount;
    this.transaction_type = data.transaction_type;
    this.happened_at = data.happened_at;
    this.description = data.description;
    this.status = data.status;
    this.current_balance = data.current_balance;
    this.code = data.code;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
  }

  mapData(data) {
    this.id = data.id;
    this.amount = data.amount;
    this.transaction_type = data.transaction_type;
    this.happened_at = data.happened_at;
    this.description = data.description;
    this.status = data.status;
    this.current_balance = data.current_balance;
    this.code = data.code;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
  }
  
  async getMatchesForOrder(orderId, threshold = 0.7, days = 14) {
    try {
      const res = await excuseApi({
        path: '/bank-transactions/matches',
        method: 'GET',
        params: {
          order_id: orderId,
          threshold: threshold,
          days: days
        }
      });

      if (res.status === 200) {
        return { 
          success: true, 
          data: res.data,
          message: res.data.message 
        };
      }
      return { success: false, message: "Không tìm thấy giao dịch phù hợp" };
    } catch (error) {
      console.error("Error in getMatchesForOrder:", error);
      return { error: error.message };
    }
  }

  // Same matcher/UX as orders, scored against an invoice.
  async getMatchesForInvoice(invoiceId, threshold = 0.7, days = 14) {
    try {
      const res = await excuseApi({
        path: '/bank-transactions/matches',
        method: 'GET',
        params: { invoice_id: invoiceId, threshold, days },
      });
      if (res.status === 200) {
        return { success: true, data: res.data, message: res.data.message };
      }
      return { success: false, message: "Không tìm thấy giao dịch phù hợp" };
    } catch (error) {
      console.error("Error in getMatchesForInvoice:", error);
      return { error: error.message };
    }
  }
  
  async mapToOrder(transactionId, orderId) {
    try {
      const res = await excuseApi({
        path: '/bank-transactions/map',
        method: 'POST',
        body: {
          transaction_id: transactionId,
          order_id: orderId
        }
      });

      if (res.status === 200) {
        return { 
          success: true, 
          data: res.data.data,
          message: res.data.message || "Ghép giao dịch thành công" 
        };
      }
      return { 
        success: false, 
        message: res.data.message || "Ghép giao dịch thất bại" 
      };
    } catch (error) {
      console.error("Error in mapToOrder:", error);
      if (error.response && error.response.data && error.response.data.message) {
        return {
          success: false,
          message: error.response.data.message
        };
      }
      return { 
        success: false, 
        message: "Ghép giao dịch thất bại: " + error.message 
      };
    }
  }

  async getBankTransactionById(id) {
    try {
      const res = await excuseApi({
        path: `/bank-transactions/${id}`,
        method: 'GET'
      });

      if (res.status === 200) {
        return { data: res.data.data };
      }
      return null;
    } catch (error) {
      console.error("Error in getBankTransactionById:", error);
      return { error: error.message };
    }
  }

  async updateBankTransaction(id) {
    try {
      const res = await excuseApi({
        path: `/bank-transactions/${id}`,
        method: 'PATCH',
        body: {
          status: this.status,
          transaction_type: this.transaction_type
        }
      });

      if (res.status === 200) {
        return { 
          success: true, 
          message: "Cập nhật giao dịch thành công",
          data: res.data.data 
        };
      }
      return { 
        success: false, 
        message: "Cập nhật giao dịch thất bại" 
      };
    } catch (error) {
      console.error("Error in updateBankTransaction:", error);
      return { 
        success: false, 
        message: "Cập nhật giao dịch thất bại: " + error.message
      };
    }
  }

  async importBankTransactions(formData) {
    try {
      const res = await excuseApi({
        path: '/bank-transactions/import',
        method: 'POST',
        body: formData,
        // Don't explicitly set Content-Type for FormData
        // Let axios set it automatically with the correct boundary
      });

      if (res.status >= 200 && res.status < 300) {
        return {
          success: true,
          message: res.data.message,
          imported: res.data.imported,
          skipped: res.data.skipped
        };
      }
      return {
        success: false,
        message: "Nhập dữ liệu thất bại"
      };
    } catch (error) {
      console.error("Error in importBankTransactions:", error);
      if (error.response && error.response.data && error.response.data.message) {
        return {
          success: false,
          message: error.response.data.message
        };
      }
      return {
        success: false,
        message: "Nhập dữ liệu thất bại: " + error.message
      };
    }
  }
}

export default BankTransaction;
